// extracted by mini-css-extract-plugin
module.exports = {"default":"Header-module__default___3JdrU","semibold":"Header-module__semibold___2qxDC","bold":"Header-module__bold___3EkNE"};